import {Component, DestroyRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {UnitOfMass} from "../../../types";

@Component({
  selector: 'app-cargo-weight-amsterdam',
  imports: [
    ReactiveFormsModule
  ],
  templateUrl: './cargo-weight-amsterdam.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cargo-weight-amsterdam.component.scss',
})
export class CargoWeightAmsterdamComponent implements OnInit, OnChanges {

  @Input() weight: number | null;

  @Input() unitOfMass: UnitOfMass = UnitOfMass.KILOGRAM;

  @Output() weightChanged = new EventEmitter<number>();

  input = new FormControl<number | null>(null);

  constructor(private destroyRef: DestroyRef) { }

  ngOnInit(): void {
    this.input.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        this.weightChanged.emit(value ? Math.ceil(value * this.unitInKilograms()) : value);
      });
    this.input.setValue(this.weight ? Math.ceil(this.weight / this.unitInKilograms()) : null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.unitOfMass && !changes.unitOfMass.isFirstChange()) {
      this.input.reset();
    }
    else if (changes.weight) {
      this.input.setValue(this.weight ? Math.ceil(this.weight / this.unitInKilograms()) : null);
    }
  }

  maxLength() {
    return this.unitOfMass === UnitOfMass.METRIC_TON ? 6 : 9;
  }

  private unitInKilograms() {
    switch (this.unitOfMass) {
      case UnitOfMass.KILOGRAM: return 1;
      case UnitOfMass.METRIC_TON: return 1000;
    }
  }

}
